import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Text, TouchableOpacity, View } from 'react-native'
import { initialize } from './i18n'
import IndicatorLightsStack, { TroubleshootingLightsStack } from './components/IndicatorLights/IndicatorLightsStack'
import CommunicatorSetupStack, { CommSetupNoMainStack, CommSetupScreens } from './components/CommSetup/CommunicatorSetupStack'
import { log, getCountryCodeFromLocale } from './utils'
import AboutAppPage from './components/AboutAppPage'
import FAQStack from './components/FAQ/FAQStack'
import * as helpers from './actions/helpers'
import InvalidStack from './components/InvalidStack'

function InitialScreen(props) {
    const [stackToUse, setStackToUse] = useState('')
    const {
      locale, selectedLanguage, webStackToLoad, setDetectedLocale,
    } = props
    let localeToUse = 'en_US'
    if (selectedLanguage) {
        log(`selectedLanguage set: ${selectedLanguage} with locale: ${locale}`)
        localeToUse = selectedLanguage.includes('_') ? selectedLanguage : `${selectedLanguage}_${getCountryCodeFromLocale(locale)}`
        log(`locale using: ${localeToUse}`)
    } else if (locale) {
        log(`locale set: ${locale}`)
        localeToUse = locale
    } else if (window.storedData) {
      log('parsing window.storedData')
      const storedData = JSON.parse(window.storedData)
      log(`window.storedData parsed, locale: ${storedData.locale}`)
      localeToUse = storedData.locale
    } else {
      let lang = window.navigator.languages ? window.navigator.languages[0] : null
      lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage

      localeToUse = lang.replace('-', '_')
      log(`detected locale: ${localeToUse}`)
      setDetectedLocale(localeToUse)
    }
    initialize(localeToUse)
    if (window.ReactNativeWebView || stackToUse) {
      log(`webStackToLoad: ${webStackToLoad}`)
      const stack = stackToUse || webStackToLoad
      switch (stack) {
        case 'TroubleshootingLightsStack':
          return (<TroubleshootingLightsStack />)
        case 'CommunicatorSetupStack':
          return (<CommunicatorSetupStack />)
        case 'CommunicatorSetupGettingStartedStack':
          return (<CommSetupScreens />)
        case 'CommunicatorSetupNoMainStack':
          return (<CommSetupNoMainStack />)
        case 'AboutAppStack':
          return (<AboutAppPage />)
        case 'FAQStack':
          return (<FAQStack />)
        case 'IndicatorLightsStack':
          return (<IndicatorLightsStack />)
        default:
          log(`unknown stack: ${stack}, url: ${window.location.href}`)
          return (<InvalidStack />)
      }
    }
    return (
      <View>
        <TouchableOpacity onPress={() => { setStackToUse('CommunicatorSetupStack') }}><Text>Comm Setup</Text></TouchableOpacity>
        <TouchableOpacity onPress={() => { setStackToUse('IndicatorLightsStack') }}><Text>Indicator Lights</Text></TouchableOpacity>
        <TouchableOpacity onPress={() => { setStackToUse('TroubleshootingLightsStack') }}><Text>Troubleshooting Lights</Text></TouchableOpacity>
        <TouchableOpacity onPress={() => { setStackToUse('AboutAppStack') }}><Text>About App</Text></TouchableOpacity>
        <TouchableOpacity onPress={() => { setStackToUse('FAQStack') }}><Text>FAQ</Text></TouchableOpacity>
      </View>
    )
}

InitialScreen.defaultProps = {
    locale: null,
    selectedLanguage: null,
    webStackToLoad: null,
}

InitialScreen.propTypes = {
    locale: PropTypes.string,
    selectedLanguage: PropTypes.string,
    webStackToLoad: PropTypes.string,
    setDetectedLocale: PropTypes.func.isRequired,
}

const actionCreators = {
  setDetectedLocale: helpers.setDetectedLocale,
}

const mapStateToProps = (state) => {
    const { storedData } = state
    return {
        locale: storedData.locale,
        selectedLanguage: storedData.selectedLanguage,
        webStackToLoad: storedData.webStackToLoad,
    }
}

export default connect(mapStateToProps, actionCreators)(InitialScreen)
